export default __webpack_public_path__ + "static/media/theory..b49b65fe.png";